import { render } from "./NavBar1pSIM.vue?vue&type=template&id=71a65d6e"
import script from "./NavBar1pSIM.vue?vue&type=script&lang=js"
export * from "./NavBar1pSIM.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__